import { store } from '@/state/store';
import { not_implemented } from '@shared/asserts/utils_asserts';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';

export abstract class SERVICE__translate_base {
  //key - word english, value - entities ids
  protected words_dependencies_map: Map<string, Set<string>> = new Map();

  /*
   * EVENTS
   */
  public on_entities_deleted(ids: string[]) {
    for (let id of ids) {
      for (let [_, entities_depended_ids] of this.words_dependencies_map) {
        entities_depended_ids.delete(id);
      }
    }
  }

  public on_received_words(words: DTO__word[]) {
    let { regional_language } = store.getState().slice_user.user_settings;

    if (regional_language == ENUM__language_type.ENGLISH) return; //no need to translate
    if (!store.getState().slice_workspace.is_all_data_loaded) return;

    for (let word of words) {
      if (regional_language != word.language) continue; //word on different from current language

      this.try_update_depended_entity_with_word(word);
    }
  }

  public on_language_changed() {
    not_implemented();
  }

  /*
   * METHODS
   */
  protected register_words_dependency(entity_id: string, words_english: string[]) {
    for (let word_english of words_english) {
      let ids = this.words_dependencies_map.get_or_create_set(word_english);

      ids.add(entity_id);
    }
  }

  protected try_update_depended_entity_with_word(word: DTO__word) {
    not_implemented();
  }
}
